import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { EventMatchLog } from '../models/event-match-log';
import { EventMatchLogStore } from '../service/event-match-log.store';
import { PagesizeType } from '../service/pagination/pagesize-type';

@Component({
  selector: 'pioneer-event-match',
  templateUrl: './event-match.component.html',
  styleUrls: ['./event-match.component.css']
})
export class EventMatchComponent implements OnInit {

  pagesizeType = PagesizeType.EVENTS;

  public dataList$: Observable<EventMatchLog[]>;

  constructor(private eventMatchLogStore: EventMatchLogStore) { }

  ngOnInit() {
    this.eventMatchLogStore.getEventMatchLog(0, 5, 'date', '', '').subscribe((data) => {
      this.dataList$ = data.content;
    });
  }

  exportEventMatchLogExcel(): void {
    this.eventMatchLogStore.exportEventMatchLogExcel().subscribe();
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/event-match/event-match.component.ts